export const adminTools = require('../svg-icons/nx-wrench.svg');
export const analytics = require('../svg-icons/nx-analytics.svg');
export const calendar = require('../svg-icons/nx-calendar.svg');
export const chat = require('../svg-icons/nx-chat.svg');
export const chatWithBadge = require('../svg-icons/nx-chat-with-badge.svg');
export const dataManagement = require('../svg-icons/nx-data-management.svg');
export const emailMarketing = require('../svg-icons/nx-email-marketing.svg');
export const formBuilder = require('../svg-icons/nx-form-builder.svg');
export const helpCenter = require('../svg-icons/nx-help-center.svg');
export const internalChat = require('../svg-icons/nx-internal-chat.svg');
export const logo = require('../svg-icons/nx-logo-nextiva-blue.svg');
export const migration = require('../svg-icons/nx-migration.svg');
export const nextIq = require('../svg-icons/nx-next-iq.svg');
export const nextOs = require('../svg-icons/nx-next-os.svg');
export const notifications = require('../svg-icons/nx-notifications.svg');
export const rulesEngine = require('../svg-icons/nx-rules-engine.svg');
export const serviceCrm = require('../svg-icons/nx-service-crm.svg');
export const smartTopics = require('../svg-icons/nx-smart-topics.svg');
export const social = require('../svg-icons/nx-social.svg');
export const support = require('../svg-icons/nx-support.svg');
export const surveys = require('../svg-icons/nx-surveys.svg');
export const tasks = require('../svg-icons/nx-tasks.svg');
export const voice = require('../svg-icons/nx-callpop.svg');
export const wiki = require('../svg-icons/nx-wiki.svg');
